import { CognitoUser } from "amazon-cognito-identity-js";
import userpool from "../Config/userpool";

/*
 * The reset screen used to be a placeholder: it never asked Cognito for a
 * code, so nothing was ever sent. Each step now waits for Cognito and turns a
 * refusal into something the person can act on.
 */
const CANNOT_SEND =
  "We couldn't send a code to this email. Check the address, or contact support@stealthjobs.co.";

const MESSAGES = {
  // * Cognito gives the same answer for an address with no account and for one
  // * whose email was never verified, so one message has to cover both. * //
  InvalidParameterException: CANNOT_SEND,
  UserNotFoundException: CANNOT_SEND,
  LimitExceededException:
    "Too many attempts. Please wait a few minutes and try again.",
  TooManyRequestsException:
    "Too many attempts. Please wait a few minutes and try again.",
  CodeMismatchException:
    "That code isn't right. Check the most recent email and try again.",
  ExpiredCodeException:
    "That code has expired. Send a new code and use the one in the newest email.",
};

const FALLBACK =
  "Something went wrong. Please try again in a moment, or contact support@stealthjobs.co.";

export const resetErrorMessage = (error) => {
  if (MESSAGES[error?.code]) return MESSAGES[error.code];
  // * Cognito's own wording is clear for password rules ("Password must have
  // * uppercase characters"), so pass it through. * //
  if (error?.code === "InvalidPasswordException" && error.message) {
    return error.message.replace(/^Password does not conform to policy: /, "");
  }
  return FALLBACK;
};

const cognitoUser = (email) =>
  new CognitoUser({ Username: email.trim(), Pool: userpool });

// * Resolves once Cognito has actually sent the code. * //
export const sendResetCode = (email) =>
  new Promise((resolve, reject) => {
    cognitoUser(email).forgotPassword({
      onSuccess: resolve,
      onFailure: reject,
    });
  });

export const confirmNewPassword = (email, code, password) =>
  new Promise((resolve, reject) => {
    cognitoUser(email).confirmPassword(code.trim(), password, {
      onSuccess: resolve,
      onFailure: reject,
    });
  });
